import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import ImageButton from 'ImageButton';
import SelfServeBuilderSidePanelConstants, { SelfServeBuilderSidePanelTypes } from './SelfServeBuilderSidePanelConstants';
import * as SelfServeBuilderSidePanelActions from './SelfServeBuilderSidePanelActions';

export { default as SelfServeBuilderSidePanelConstants } from './SelfServeBuilderSidePanelConstants';
export { SelfServeBuilderSidePanelTypes } from './SelfServeBuilderSidePanelConstants';
export { default as SelfServeBuilderSidePanelHandler } from './SelfServeBuilderSidePanelReducer';

export class SelfServeBuilderSidePanel extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onOpenPanel = this.onOpenPanel.bind(this, this.props.panelType);
    this.onClosePanel = this.onClosePanel.bind(this, this.props.panelType);
    this.getImageButton = this.getImageButton.bind(this);
  }

  onOpenPanel(panelType) {
    window._track('Open Sidebar', 'Template Builder');
    this.props.openPanel(panelType);
  }

  onClosePanel(panelType) {
    this.props.closePanel(panelType);
  }

  getImageButton() {
    const panelState = this.props[this.props.panelType];

    const src = panelState.isOpen ? '/images/self-serve-builder/close-default-2x.png' : '/images/self-serve-builder/open-default-2x.png';
    const srcHover = panelState.isOpen ? '/images/self-serve-builder/close-hover-2x.png' : '/images/self-serve-builder/open-hover-2x.png';
    return (
      <ImageButton
        className="self-serve-builder-side-panel-button"
        src={src}
        srcHover={srcHover}
        style={{
          borderRadius: '50%',
          boxShadow: '0 0 7px 0 rgba(0,0,0,0.3)',
          height: 24,
          margin: 0,
          maxWidth: 'none',
          outline: 'none',
          padding: 0,
          position: 'absolute',
          top: 18,
          width: 24,
          [this.props.leftPlacement ? 'right' : 'left']: -12,
        }}
        onClick={panelState.isOpen ? this.onClosePanel : this.onOpenPanel}
        alt={panelState.isOpen ? 'Close' : 'Open'}
      />
    );
  }

  render() {
    // if parent has 'min-height', parent must have position relative to inherit height
    const panelState = this.props[this.props.panelType];
    const displayPanelContent = (
      !this.props.collapsible ||
      (this.props.collapsible && panelState.isOpen)
    );
    const panelClassNames = classnames(
      'self-serve-builder-side-panel',
      {
        'self-serve-builder-side-panel-open': this.props.collapsible ? panelState.isOpen : true,
        'self-serve-builder-side-panel-left': this.props.leftPlacement,
        'self-serve-builder-side-panel-right': !this.props.leftPlacement,
        toolbox: this.props.panelType === SelfServeBuilderSidePanelTypes.TOOLBOX,
        'self-serve-builder-side-panel-with-overlay': this.props.isOverlayVisible,
      },
    );

    return (
      <div
        className={panelClassNames}
        style={{
          width: displayPanelContent ? this.props.openWidth : this.props.closeWidth,
        }}
      >

        {this.props.collapsible && panelState.isOpen &&
          this.getImageButton()
        }

        {displayPanelContent &&
          this.props.children
        }

      </div>
    );
  }
}


SelfServeBuilderSidePanel.propTypes = {
  collapsible: PropTypes.bool,
  leftPlacement: PropTypes.bool,
  isOverlayVisible: PropTypes.bool,
  panelType: PropTypes.oneOf([
    SelfServeBuilderSidePanelTypes.POST_BUILDER,
    SelfServeBuilderSidePanelTypes.TOOLBOX,
  ]).isRequired,
  openPanel: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
  openWidth: PropTypes.number,
  closeWidth: PropTypes.number,
  children: PropTypes.node,
};

SelfServeBuilderSidePanel.defaultProps = {
  collapsible: true,
  leftPlacement: false,
  children: null,
  isOverlayVisible: false,
  openWidth: SelfServeBuilderSidePanelConstants.DEFAULT_OPEN_PANEL_WIDTH,
  closeWidth: SelfServeBuilderSidePanelConstants.DEFAULT_CLOSE_PANEL_WIDTH,
};

const mapStateToProps = ({ SelfServeBuilderSidePanelHandler }) => (
  {
    ...SelfServeBuilderSidePanelHandler,
  }
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    ...SelfServeBuilderSidePanelActions,
  }, dispatch)
);

const SelfServeBuilderSidePanelWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelfServeBuilderSidePanel);


export default SelfServeBuilderSidePanelWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderSidePanel/index.jsx